var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gr-drop-item",class:`size-${_setup.sizeDropDown}`,attrs:{"tabindex":"0"},on:{"click":_setup.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }